import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = ({ message }) => {
  const { t } = useTranslation();
  const text = message || t('common.loading');
  return (
    <div className="fixed inset-0 flex items-center justify-center" style={{ background: 'rgba(7,6,10,0.85)', backdropFilter: 'blur(6px)', zIndex: 50 }}>
      <div className="okcard" style={{ padding: 24, textAlign: 'center' }}>
        <div className="animate-spin rounded-full h-16 w-16 mx-auto mb-4" style={{ border: '3px solid rgba(200,144,42,0.18)', borderTopColor: 'var(--okoyl-300)' }}></div>
        <p className="oklore oklore-sm" style={{ marginTop: 8 }}>{text}</p>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = { message: PropTypes.string };

export default LoadingSpinner;
